import { FC } from 'react';
import { TYScaleProps } from './types';

export const YScale: FC<TYScaleProps> = ({ chart }) => {
	return (
		<div
			style={{
				width: '55px',
				fontSize: '14px',
				color: '#016193',
			}}
		>
			{chart.map((item, index) => (
				<div
					key={`y${item.y}-${index}`}
					style={{ marginBottom: '20px', minHeight: '20px', height: '20px' }}
				>
					{item.y}
				</div>
			))}
		</div>
	);
};
